<template>
  <div class="cmo-container">
    <!-- banner -->
    <div class="cmo-banner">
      <Carousel autoplay>
        <div class="banner">
          <img class="img-banner" src="../assets/img/ban-260326.jpg" />
        </div>
        <div class="banner">
          <img class="img-banner" src="../assets/img/banner1-1.jpg" />
        </div>
        <div class="banner">
          <img class="img-banner" src="../assets/img/banner2.jpg" />
        </div>
        <div class="banner">
          <img class="img-banner" src="../assets/img/banner3.jpg" />
        </div>
      </Carousel>
      <div class="decorate"></div>
    </div>
    <!-- 赛事资讯 -->
    <div class="event-wrap event-news">
      <div
        class="event-action"
        v-if="newsList && newsList[1]"
        @click="navigateChange('news', 1)"
      >
        查看全部
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="11"
          viewBox="0 0 7 11"
          fill="none"
        >
          <path d="M1 1L5.5 5.5L1 10" stroke="#999999" />
        </svg>
      </div>
      <div class="event-title">赛事资讯</div>
      <div class="event-inner" v-if="newsList && newsList[1]">
        <div
          v-for="(item, index) in newsList[1]"
          :key="index"
          class="event-item"
          @click="navigateChange('news', 1, item.id)"
        >
          <div class="item-time">{{ getDate(item.showDate) }}</div>
          <div class="item-inner">
            <div class="item-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div v-else class="empty">暂无资讯</div>
    </div>
    <!-- 竞赛通知 -->
    <div class="event-wrap event-notice">
      <div
        class="event-action"
        v-if="newsList && newsList[2]"
        @click="navigateChange('news', 2)"
      >
        查看全部
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="11"
          viewBox="0 0 7 11"
          fill="none"
        >
          <path d="M1 1L5.5 5.5L1 10" stroke="#999999" />
        </svg>
      </div>
      <div class="event-title">竞赛通知</div>
      <div class="event-inner" v-if="newsList && newsList[2]">
        <div
          v-for="(item, index) in newsList[2]"
          :key="index"
          class="event-item"
          @click="navigateChange('news', 1, item.id)"
        >
          <div class="item-time">{{ getDate(item.showDate) }}</div>
          <div class="item-inner">
            <div class="item-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div v-else class="empty">暂无通知</div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import service from "../service/index";
import { reactive, onMounted } from "vue";
import { Carousel } from "ant-design-vue/es";

const router = useRouter();
const newsList = reactive({
  1: null,
  2: null,
});

const navigateChange = (path, type, id) => {
  const query = { type };
  if (id) {
    query.id = id;
  }
  router.push({ path, query });
};

const getNewsType = async () => {
  const res = await service.dataSearch.getNewsType();
  console.log(200, res);
  const { ok, data } = res;
  if (ok) {
    let type = [];
    for (let i = 0; i < data.length; i++) {
      type.push(data[i].id);
    }
    const newsRes = await service.dataSearch.getNewsList({
      type: type.join(","), // 新闻类型，多个类型逗号分隔
      page: 1, // 不传默认1
      size: 4, // 不传默认10?
      status: 1, // 内容状态，-1:删除，0:未发布，1:已发布，不传默认为1
    });
    console.log(200, newsRes);
    const { ok, data: newsData } = newsRes;
    if (ok) {
      Object.assign(newsList, newsData.list);
      console.log("newsList", newsData.list, newsList);
    }
  }
};

const getDate = (date) => {
  return date.split("-").join(".");
};

onMounted(() => {
  getNewsType();
});
</script>

<style lang="less" scoped>
@import "../assets/css/theme.less";
body {
  font-family: "Microsoft YaHei UI";
  text-align: center;
  margin: 0;
  padding: 0;
  background: @Background-5;
}
.cmo-container {
  .cmo-banner {
    width: 100%;
    height: fit-content;
    background: @Background-0;
    font-size: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;
    .decorate {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 55%;
      pointer-events: none;
      background: linear-gradient(180deg, rgba(255, 118, 19, 0) 0%, @Main 100%);
      opacity: 0.5;
    }
  }
  .event-wrap {
    position: relative;
    padding: 32px 10vw;
    &:nth-child(even) {
      background: @Background-5;
    }
    &:nth-child(odd) {
      background: @Background-1;
    }
    .event-action {
      display: inline-flex;
      padding: 4px 8px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 4px;
      background: @Gray-e;
      position: absolute;
      top: 44px;
      right: 10vw;
      z-index: 5;
      color: @Gray-9;
      text-align: right;
      font-family: "Microsoft YaHei UI";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      cursor: pointer;
    }
    .event-title {
      color: @Gray-3;
      font-family: "Microsoft YaHei UI";
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px;
      margin-bottom: 36px;
      position: relative;
      text-align: left;
      &:after {
        content: " ";
        display: block;
        position: absolute;
        width: 20px;
        height: 4px;
        background: @Main;
        bottom: -16px;
        left: 0;
      }
    }
    .event-inner {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      align-items: center;
      justify-content: flex-start;
      .event-item {
        border-radius: 4px;
        background: rgba(238, 238, 238, 0.5);
        display: flex;
        cursor: pointer;
        .item-time {
          width: 118px;
          padding: 20px;
          box-sizing: border-box;
          text-align: left;
          position: relative;
          color: @Main;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          &:after {
            content: " ";
            display: block;
            position: absolute;
            width: 1px;
            height: 18px;
            background: @Gray-d;
            bottom: 20px;
            right: 0;
          }
          .date {
            color: @Main;
            font-family: "Microsoft YaHei UI";
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            line-height: 36px;
          }
          .month {
            margin-top: 11px;
            color: @Gray-9;
            font-family: "Microsoft YaHei UI";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 15px;
          }
        }
        .item-inner {
          width: calc(100% - 86px);
          // flex: 1;
          padding: 20px;
          box-sizing: border-box;
          text-align: left;
          .item-title {
            width: calc(100% - 40px);
            color: @Gray-3;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .item-explain {
            width: calc(100% - 40px);
            margin-top: 12px;
            color: @Gray-9;
            font-family: "Microsoft YaHei UI";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
      }
    }
    .empty {
      color: #999999;
    }
  }
}
.cmo-banner .banner {
  display: flex !important;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
/* 当屏幕宽度小于1100像素时应用的样式 */
@media (max-width: 1000px) {
  .cmo-banner .img-banner {
    width: auto;
    height: 180px;
  }
  :deep(.slick-slide) {
    width: 100vw;
    height: fit-content;
  }
  .event-item {
    width: 80vw;
    min-height: 58px;
    height: fit-content;
  }
}

/* 当屏幕宽度大于1100像素时应用的样式 */
@media (min-width: 1000px) {
  :deep(.slick-slide) {
    width: 100vw;
    height: 400px;
  }
  .cmo-banner .img-banner {
    width: auto !important;
    height: 400px;
  }
  .event-item {
    width: calc(50vw - 20px - 10vw);
    height: 58px;
  }
}
.ant-carousel {
  width: 100%;
  font-size: 0;
}
</style>
